@if (areGamesAvailable()) {
    <cs-feature-container
        [enableNavigation]="swiperConfig?.enableNavigation"
        [chunkSize]="swiperConfig?.chunkSize"
        [swipeSize]="swiperConfig?.swipeSize">
        <cs-container-description
            slot="top-left"
            [isLegacy]="'true'"
            [titleText]="containerDescriptionConfig?.titleText"
            [subtitleText]="containerDescriptionConfig?.subtitleText"
            [titleInlineStyle]="containerDescriptionConfig?.titleInlineStyle"
            [subtitleInlineStyle]="containerDescriptionConfig?.subtitleInlineStyle"
            [iconClass]="containerDescriptionConfig?.iconClass"
            [subtitleClass]="containerDescriptionConfig?.subtitleClass">
        </cs-container-description>
        @for (game of topTenGames; track game.id; let tilePosition = $index) {
            <div #containerContent>
                <cc-top-ten-game-tile
                    id="gameIdentifier_{{ subCategory.categoryid }}_{{ game.gameId }}"
                    [attr.data-productid]="subCategory.categoryid + '_' + game.gameId"
                    [topTenGame]="game"
                    [isLegacy]="'true'"
                    [lobbyType]="lobbyType"
                    [subCategory]="subCategory"
                    [tileIndex]="tilePosition + 1" />
            </div>
        }
    </cs-feature-container>
}
